module.exports = __webpack_public_path__ + "static/media/yotpo-circle@2x.aba8729d.png";